import { TableCell, styled } from "@mui/material";

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  color: theme.palette.text.main,
  fontWeight: 700,
}));
